export const ContactPage = {
  title: 'Contact us',
  heading: 'Talk to us about your marketing',
  description: "Questions about our services, pricing, or how we work? Send a message and we'll get back to you.",
};

export const ContactFormContent = {
  title: 'Send us a message',
  messagePlaceholder: 'How can we help?',
  submitLabel: 'Send message',
  submittingLabel: 'Sending message',
  privacyNote: 'We only use these details to reply to you.',
  success: {
    title: 'Message sent',
    description: "Thanks for reaching out. We'll reply to your email shortly.",
    actionLabel: 'Send another message',
  },
};

export const ContactDetailsCardContent = {
  title: 'Other ways to reach us',
  emailLabel: 'Email',
  phoneLabel: 'Phone',
  hoursLabel: 'Office hours',
};

export const ProjectPrompt = {
  title: 'Ready to talk about a plan?',
  description: 'The Get started form tells us what we need to put together a marketing plan and a price for your company.',
};